module.exports = __webpack_public_path__ + "static/img/logo_thumb.95c834b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_thumb.png
// module id = povs
// module chunks = 1